import { render, staticRenderFns } from "./LoaderComponent.vue?vue&type=template&id=6e4cf74d&scoped=true"
import script from "./LoaderComponent.vue?vue&type=script&lang=js"
export * from "./LoaderComponent.vue?vue&type=script&lang=js"
import style0 from "./LoaderComponent.vue?vue&type=style&index=0&id=6e4cf74d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4cf74d",
  null
  
)

export default component.exports